import styled from 'styled-components';

import { Breakpoint, Color } from '../../enums';
import { StyledComponent } from '../../interfaces';

export const Container: StyledComponent<'div'> = styled.div`
  max-width: 100%;
  display: flex;
  border: 1px solid ${Color.Gray300};
`;

export const IconContainer: StyledComponent<'div'> = styled.div`
  width: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 1px solid ${Color.Gray300};
  flex-shrink: 0;

  @media ${Breakpoint.Mobile} {
    width: 64px;
  }
`;

export const MessageContainer: StyledComponent<'div'> = styled.div`
  padding: 16px;
`;

export const Message: StyledComponent<'div'> = styled.div`
  font-size: 14px;
  line-height: 18px;
  color: ${Color.Black};
`;
